import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

function assertConfig() {
  const required = [
    ['REACT_APP_FIREBASE_API_KEY', firebaseConfig.apiKey],
    ['REACT_APP_FIREBASE_AUTH_DOMAIN', firebaseConfig.authDomain],
    ['REACT_APP_FIREBASE_PROJECT_ID', firebaseConfig.projectId],
    ['REACT_APP_FIREBASE_STORAGE_BUCKET', firebaseConfig.storageBucket],
    ['REACT_APP_FIREBASE_MESSAGING_SENDER_ID', firebaseConfig.messagingSenderId],
    ['REACT_APP_FIREBASE_APP_ID', firebaseConfig.appId],
  ];
  const missing = required.filter(([, v]) => !v).map(([k]) => k);
  if (missing.length) {
    throw new Error(
      `Missing Firebase env: ${missing.join(', ')}. Copy .env.example to .env and add your Firebase Web App config.`
    );
  }
}

let app;
export function getFirebaseApp() {
  if (!getApps().length) {
    assertConfig();
    app = initializeApp(firebaseConfig);
  }
  return app || getApps()[0];
}

export function getFirebaseAuth() {
  return getAuth(getFirebaseApp());
}

export function getFirebaseDb() {
  return getFirestore(getFirebaseApp());
}

export function getFirebaseStorage() {
  return getStorage(getFirebaseApp());
}

export function getFirebaseFunctions() {
  return getFunctions(getFirebaseApp(), 'us-central1');
}
